@if (icon()) {
  <i class="material-icons">{{ icon() }}</i>
}
